import axios from 'axios';
import { serverHost } from '../../redux/reducers/reducer';

export default async function RefreshToken() {
    const server = serverHost();
    axios.defaults.withCredentials = true;
    
    try {
        // Ensure we don't have a stale token
        delete axios.defaults.headers.common['authorization'];
        
        const response = await axios.post(`${server}/user/token`);
        
        if (response?.status === 200 && response.data?.data) {
            const data = response.data.data;
            const accessToken = data?.accessToken;
            const roles = data?.roles;
            const sites_list = data?.sites_list;
            const userName = data?.userName;
            const userId = data?.userId;

            if (!accessToken) {
                console.error('RefreshToken: No access token in response');
                return null;
            }

            // Set the new access token for future requests
            axios.defaults.headers.common['authorization'] = `Bearer ${accessToken}`;

            // Get the stored site preference, defaulting to the first available site
            const storage_site = localStorage.getItem('relevantSite');
            const relevant_site = storage_site && sites_list?.includes(storage_site) 
                ? storage_site 
                : sites_list?.[0] || 'develop';

            // Check user roles
            const isManager = roles?.includes("Manager");
            const isAdmin = roles?.includes("Admin");
            const isOperator = roles?.includes("Operator");
            const isSiteManager = roles?.includes("Site_Manager");

            return {
                accessToken,
                roles,
                sites_list,
                userName,
                relevant_site,
                isManager,
                isAdmin,
                isOperator,
                isSiteManager,
                userId
            };
        }
        console.error('RefreshToken: Invalid response:', response);
        return null;
    } catch (err) {
        console.error("RefreshToken error:", err.message);
        // Clear auth header if refresh failed
        delete axios.defaults.headers.common['authorization'];
        return null;
    }
}
